// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UARange
 */
export interface UARange {
    /**
     * 
     */
    low?: number;
    /**
     * 
     */
    high?: number;
}

/**
 * Check if a given object implements the UARange interface.
 */
export function instanceOfUARange(value: object): value is UARange {
    return true;
}

export function UARangeFromJSON(json: any): UARange {
    return UARangeFromJSONTyped(json, false);
}

export function UARangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UARange {
    if (json == null) {
        return json;
    }
    return {
        
        'low': json['low'] == null ? undefined : json['low'],
        'high': json['high'] == null ? undefined : json['high'],
    };
}

export function UARangeToJSON(json: any): UARange {
    return UARangeToJSONTyped(json, false);
}

export function UARangeToJSONTyped(value?: UARange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'low': value['low'],
        'high': value['high'],
    };
}

